import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { FEATURES, PROGRAM_CLI_MOVIES_ITEMS } from '../../../constants/state'
import getData from '../../../functions/getData'
import getImageUrl from '../../../functions/getImageUrl'
import ListItem from '../presents/ListItem'
import hasDisplayTimes from '../functions/hasDisplayTimes'
import isOutOfRange from '../functions/isOutOfRange'
import ListItemNoDataContainer from './ListItemNoDataContainer'

const mapStateToProps = (state, ownProps) => ({
    movieData:  ownProps.itemData && ownProps.itemData.movieRefID ? getData(state, [PROGRAM_CLI_MOVIES_ITEMS, ownProps.itemData.movieRefID]) : false,
    hasMcsApp: getData(state, [FEATURES, 'has_mcs_app']),
})

const ListItemWithMovieContainer = ({
    itemType,
    itemData,
    movieData,
    additionalClass,
    isSelected,
    hasMcsApp,
    pathnameEdit,
    onDelete,
}) => {
    if(!itemData) {
        return <ListItemNoDataContainer onDelete={onDelete} />
    }

    const { title } = itemData
    const movieTitle = movieData && (movieData.titleDisplay || movieData.title)
    const currentTitle = title ? title : movieTitle ? movieTitle : ''

    const hasTimes = hasDisplayTimes(itemData)
    const outRange = hasTimes && isOutOfRange(itemData)

    let poster = null

    if(itemData.imagePoster && itemData.imagePoster.url)  {
        poster = itemData.imagePoster
    } else if(movieData && movieData.images &&  movieData.images.poster && movieData.images.poster.url ) {
        poster = movieData.images.poster
    }

    const {finalImageURl, imageUrl} = getImageUrl(poster, false, true)

    return <ListItem
        title={currentTitle}
        showImage={true}
        imageSrc={finalImageURl}
        imageSrcFallback={imageUrl}
        type={itemType}
        additionalClass={additionalClass}
        isSelected={isSelected}
        isInApp={hasMcsApp && itemData.showInApp}
        hasDisplayTimes={hasTimes}
        isOutOfRange={outRange}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemWithMovieContainer)